import { emitDashboardStatus } from './statusEvents';

const notify = (type, message, options = {}) => {
  emitDashboardStatus({
    type,
    message,
    durationMs: 5_000,
    ...options,
  });
};

export const notifySuccess = (message, options = {}) => notify('success', message, options);
export const notifyError = (message, options = {}) => notify('error', message, options);
export const notifyWarning = (message, options = {}) => notify('warning', message, options);
export const notifyInfo = (message, options = {}) => notify('info', message, options);

export const notifyErrorFrom = (error, fallback, options = {}) => {
  notifyError(error?.message || fallback, options);
};
